import { twMerge } from 'tailwind-merge'

import { ModalGalleryContext } from './GalleryContext'

interface CloseButtonProps {
  className?: string
}

export function CloseButton({ className }: CloseButtonProps) {
  const [, sendToModalGallery] = ModalGalleryContext.useActor()

  const handleClick = () => {
    sendToModalGallery({ type: 'Deactivate gallery' })
  }

  return (
    <button
      aria-label="Close gallery"
      className={twMerge(
        'flex aspect-square h-6 w-6 cursor-pointer justify-center rounded-full duration-300 focus-visible:outline-none md:drop-shadow-[0_2px_4px_rgba(0,0,0,0.85)] lg:hover:scale-110 lg:focus-visible:scale-110',
        className,
      )}
      onClick={handleClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-6 w-6 stroke-white stroke-[3px] drop-shadow-2xl sm:h-8 sm:w-8 sm:stroke-2"
        fill="none"
      >
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.714"
          d="M23.143.86.857 23.144M.857.86l22.286 22.285"
        />
      </svg>
    </button>
  )
}
